var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuoteExpired(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#F2A83B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0046 0C10.2904 0 6.72824 1.47623 4.10187 4.10394C1.47551 6.73164 3.54442e-05 10.2956 3.54442e-05 14.0117C-0.00642326 16.8691 0.869951 19.6586 2.50918 21.9984C2.95211 22.6415 3.45207 23.2433 4.003 23.7966C5.30205 25.1225 6.85153 26.1769 8.56141 26.8985C10.2713 27.6201 12.1075 27.9945 13.9632 27.9999C15.819 28.0054 17.6573 27.6417 19.3714 26.9302C21.0854 26.2186 22.641 25.1733 23.9478 23.8549C24.5056 23.309 25.0098 22.7108 25.4533 22.0684C26.9272 19.9702 27.7973 17.5075 27.9687 14.9486C28.1401 12.3898 27.6062 9.83294 26.4254 7.55669C25.2445 5.28045 23.4619 3.37213 21.2717 2.03966C19.0815 0.707185 16.5679 0.00167535 14.0046 0ZM23.7728 20.387C23.3505 21.039 22.8574 21.642 22.3023 22.1852C21.216 23.292 19.9201 24.1711 18.4904 24.7713C17.0607 25.3714 15.5258 25.6805 13.9754 25.6805C12.425 25.6805 10.8901 25.3714 9.4604 24.7713C8.0307 24.1711 6.73485 23.292 5.64854 22.1852C5.09676 21.6166 4.60768 20.9902 4.18973 20.317C2.9738 18.4394 2.32915 16.2489 2.33413 14.0117C2.33413 10.9149 3.56369 7.94499 5.75233 5.75523C7.94096 3.56548 10.9094 2.33529 14.0046 2.33529C17.0998 2.33529 20.0682 3.56548 22.2569 5.75523C24.4455 7.94499 25.6751 10.9149 25.6751 14.0117C25.6784 16.2773 25.017 18.4941 23.7728 20.387Z",
    fill: "#F2A83B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0005 19.8466C17.2292 19.8466 19.8466 17.2292 19.8466 14.0005C19.8466 10.7717 17.2292 8.1543 14.0005 8.1543C10.7717 8.1543 8.1543 10.7717 8.1543 14.0005C8.1543 17.2292 10.7717 19.8466 14.0005 19.8466Z",
    stroke: "white",
    strokeWidth: 1.10769
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10.9229V13.9998L15.8462 15.2305",
    stroke: "white",
    strokeWidth: 1.10769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteExpired);
export default __webpack_public_path__ + "static/media/quote-expired.bd7a09c7.svg";
export { ForwardRef as ReactComponent };